/* @flow */
import AdminUpgradeShareQuoteBanner from './AdminUpgradeShareQuoteBanner';

export default AdminUpgradeShareQuoteBanner;
